export const FETCH_USERS_TEXTED = "FETCH_USERS_TEXTED"